import { HorizontalSpacer, Img, Link, theme } from '@superhi/design'
import { BREAKPOINTS } from '@superhi/design/dist/cjs/theme/media'
import styled from 'styled-components'

import { WRAPPER_PADDING, CONTENT_PADDING } from 'src/components/page-headers/PageHeader/styles'

export const WebsiteWrapper = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid ${theme.colors.GREY_50};
  background-color: ${theme.colors.PALE_BLUE_40};
  overflow: scroll;

  &:after {
    display: block;
    content: '';
    padding-top: 160%;

    @media ${theme.breakpoints.medium} {
      padding-top: 120%;
    }

    @media ${theme.breakpoints.large} {
      padding-top: 56.25%;
    }
  }
`

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid ${theme.colors.GREY_50};
  background-color: ${theme.colors.PALE_BLUE_40};
  overflow: scroll;

  &:after {
    display: block;
    content: '';
    padding-top: 56.25%;
  }
`

export const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  border: 0;
  background-color: ${theme.colors.WHITE};
`

export const WebsiteError = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${theme.colors.TRANSPARENT_GREY_65};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`

export const WebsiteFallbackImage = styled(Img)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const Info = styled.div`
  margin-top: 16px;
`

export const InfoUser = styled(HorizontalSpacer).attrs({
  amount: { small: 16, medium: 16, large: 16 },
})`
  display: flex;
  justify-content: center;

  @media ${theme.breakpoints.medium} {
    justify-content: flex-start;
  }
`

export const InfoUrl = styled.div`
  display: flex;
  justify-content: center;

  @media ${theme.breakpoints.medium} {
    justify-content: flex-end;
  }
`

export const Header = styled.div`
  padding: ${WRAPPER_PADDING.small + CONTENT_PADDING.small}px 0;

  @media ${theme.breakpoints.medium} {
    padding: ${WRAPPER_PADDING.medium + CONTENT_PADDING.medium}px 0;
  }

  @media ${theme.breakpoints.large} {
    padding: ${WRAPPER_PADDING.large + CONTENT_PADDING.large}px 0;
  }
`

export const Image = styled(Img)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`

export const PreviousNextWrapper = styled.div`
  position: relative;
`

export const PreviousNextButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 16px 0 16px;

  > *:not(:last-child) {
    margin-right: 1px;
  }
`

export const PreviousButton = styled(Link).attrs({
  color: 'BLUE_50',
  hoverColor: 'BLUE_60',
})`
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: currentColor;

  @media ${theme.breakpoints.medium} {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  @media (min-width: ${BREAKPOINTS.xlarge + 40}px) {
    width: auto;
    height: auto;
    padding: 16px;
  }
`

export const NextButton = styled(PreviousButton)`
  left: auto;
  right: 0;
`
